import { createRouter, createWebHashHistory } from 'vue-router';
import { useAppStore } from './stores/useAppStore';

import Onboarding from './views/Onboarding.vue';
import CreateBaby from './views/CreateBaby.vue';
import Timeline from './views/Timeline.vue';
import Settings from './views/Settings.vue';
import VaccineDetail from './views/VaccineDetail.vue';
import Privacy from './views/Privacy.vue';
import Terms from './views/Terms.vue';

const routes = [
  { path: '/', component: Onboarding },
  { path: '/create', component: CreateBaby },
  { path: '/timeline', component: Timeline },
  { path: '/settings', component: Settings },
  { path: '/vaccine/:id', component: VaccineDetail },
  { path: '/privacy', component: Privacy },
  { path: '/terms', component: Terms },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

router.beforeEach((to, _from, next) => {
  const store = useAppStore();

  // 允許訪問 Onboarding、CreateBaby、Privacy、Terms 頁面
  const allowedPaths = ['/', '/create', '/privacy', '/terms'];

  if (!allowedPaths.includes(to.path) && !store.hasOnboarded) {
    // 如果沒有完成 onboarding，且不是允許的路徑，跳轉到首頁
    next('/');
  } else if (to.path === '/' && store.hasOnboarded) {
    // 如果已完成 onboarding，且訪問首頁，跳轉到 Timeline
    next('/timeline');
  } else {
    next();
  }
});

export default router;